<template>
    <div class="ui footer segment" style="position: relative;">
        <div class="ui center aligned container">
            <div class="ui horizontal inverted small divided list">
                <p>
                    Copyright © {{ current_year }} Genki Inc. All rights reserved
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterBar",
    computed: {
        current_year() {
            return (new Date()).getFullYear()
        }
    }
}
</script>

<style scoped lang="scss">
</style>
